import React from 'react';
import './App.css';
import Router from "./router/Router";
import store from "./reducers/store";
import { Provider } from "react-redux"
import ThemeCustomization from "./themes";
import Locales from "./components/Locales";
import Notistack from "./components/third-party/Notistack";
import Customization from "./components/Customization";
import Snackbar from "./components/@extended/Snackbar";
import { ConfigProvider } from "./contexts/ConfigContext";
import { AuthProvider } from "./config/AuthProvider";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { LocalizationProvider } from '@mui/x-date-pickers';

function App() {
    return (
        <ConfigProvider>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
                <Provider store={store}>
                    <AuthProvider>
                        <ThemeCustomization>
                            <Locales>
                                <Notistack>
                                    <Router />
                                    <Customization />
                                    <Snackbar />
                                </Notistack>
                            </Locales>
                        </ThemeCustomization>
                    </AuthProvider>
                </Provider>
            </LocalizationProvider>
        </ConfigProvider>
    );
}

export default App;
